import React, { useState } from 'react';

const WelcomePage = ({ onContinue }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleCreateItinerary = () => {
    setIsLoading(true);
    // Simulate loading time
    setTimeout(() => {
      onContinue();
    }, 2500);
  };

  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50 px-4 py-2">
      <div className="max-w-5xl w-full bg-white rounded-lg shadow-xl overflow-hidden">
        <div className="bg-linear-to-r from-blue-600 to-indigo-800 p-4 flex justify-between items-center">
          <div>
            <h2 className="text-white text-xl font-bold">Booking Confirmation</h2>
            <p className="text-blue-100 text-sm">Your reservation has been confirmed</p>
          </div>
          <div className="text-white font-bold text-xl mr-4">go-book-now.com</div>
        </div>
        
        <div className="p-4">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="md:w-2/5">
              <img 
                src="/images/theplaza.png" 
                alt="The Plaza Hotel" 
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
            
            <div className="md:w-3/5">
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                Go-book-now.com Assistant
              </h3>
              <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 mb-4">
                <p className="text-gray-800 text-sm">
                  Thank you for booking The Plaza Hotel! Your reservation is now confirmed for May 23 - May 29 (7 nights).
                </p>
                <p className="text-gray-800 text-sm mt-2">
                  Based on your booking information, this appears to be a business trip to New York. I've created a preliminary itinerary for you with some suggested activities.
                </p>
                <p className="text-gray-800 text-sm mt-2">
                  The Plaza Hotel is a 5-star luxury property located at Central Park South with an exceptional 9.2/10 rating from guests. Do you have some free time during this business trip? If so, I'd be happy to help you schedule some activities or attractions to visit.
                </p>
              </div>
              
              <div>
                <p className="text-base font-medium text-gray-700 mb-3">Would you like me to create an itinerary for your trip?</p>
                
                <div className="flex gap-3">
                  <button
                    onClick={handleCreateItinerary}
                    disabled={isLoading}
                    className={`${
                      isLoading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'
                    } text-white font-semibold py-2 px-4 rounded-md transition duration-150 flex justify-center items-center`}
                  >
                    {isLoading ? (
                      <>
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Creating Itinerary...
                      </>
                    ) : (
                      'Yes, Create My Itinerary'
                    )}
                  </button>
                  
                  <button
                    onClick={onContinue}
                    disabled={isLoading}
                    className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-md transition duration-150"
                  >
                    No, Thanks
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-gray-50 px-4 py-3 border-t">
          <div className="flex items-center justify-between">
            <p className="text-xs text-gray-600">
              Booking reference: <span className="font-semibold">NYC-1234567</span>
            </p>
            <p className="text-xs text-gray-600">
              Need help? Contact <a href="mailto:support@go-book-now.com" className="text-blue-600 hover:underline">support@go-book-now.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;